import React from 'react';
import { View, Text, ViewProps } from 'react-native';
import useStyles from './Counter.styles';

export type CounterProps = ViewProps & {
  variant?: 'secondary' | 'primary' | 'prominent' | 'badge';
  /**
   * XS counter doesn't have any text and is represented as a colored badge.
   */
  size?: 'xs' | 's' | 'm';
};

export const Counter: React.FC<CounterProps> = ({
  variant = 'secondary',
  size = 'm',
  children,
  style,
  ...props
}) => {
  const s = useStyles({ variant, size });

  return (
    <View style={[s.root, style]} {...props}>
      {size === 'xs' && <View style={s.badge} />}
      {size !== 'xs' && <Text style={s.content}>{children}</Text>}
    </View>
  );
};
